<div class="call-icon" [ngClass]="{
        'call-icon-pulse': !isConnected && !callEnded && !callFailed && !callRejected
      }">

  <ion-icon *ngIf="callFailed || callRejected" @iconChange src="./assets/icon/call-failed.svg"></ion-icon>


  <ion-icon *ngIf="callEnded && !callFailed && !callRejected" @iconChange src="./assets/icon/call-ended.svg"></ion-icon>


  <ion-icon *ngIf="isConnected && !callEnded && !callFailed && !callRejected" @iconChange src="./assets/icon/call-active.svg"></ion-icon>


  <ion-icon *ngIf="!isConnected && !callEnded && !callFailed && !callRejected" @iconChange src="./assets/icon/call-ringing.svg"></ion-icon>
</div>


<div class="divider"></div>


<div class="status">
  <h2 style="white-space: break-spaces;">{{ callStatus }}</h2>
</div>


<div class="timer" *ngIf="isConnected || (callEnded && callWasConnected)">
  <h2 class="timer-text">{{ callDuration }}</h2>
</div>


<div class="ok-button" *ngIf="callEnded">
  <ion-button (click)="closeModal()">OK</ion-button>
</div>
